import React from 'react';
import { func, types } from 'utils';
import { _store, _update } from '_Store';
import { RouteComponentProps } from 'react-router';
import Touchable from './Touchable';
import { useIonRouter } from '@ionic/react';

interface StateProps {
	item: types.Store;
	layout: 'list' | 'grid';
}
interface Props extends RouteComponentProps, types.StateProps, StateProps {}
const Store: React.FC<Props> = (props) => {
	const router = useIonRouter();

	const { item, layout } = props;

	const {
		__data: { promotions },
	} = _store.useState();

	const isOpen = func.isOpen(item);
	const hasPromo = promotions.find((p) => p.stores.includes(item.code));

	return (
		<React.Fragment>
			<Touchable
				onClick={() => {
					if (isOpen.open) {
						// func.setStorage('new_venue', 'yes');
						_update.data('activeStore', item, () =>
							router.push(`/store/${item.code}.${item.slug}`)
						);
					}
				}}
			>
				{layout === 'list' && (
					<div id="Store" className="mb-4s">
						<div
							className="bg-img pop"
							style={{
								backgroundImage: `url("${item.coverLink}")`,
								borderRadius: 7,
								height: '15vh',
							}}
						>
							{!isOpen.open && (
								<div className="closed d-flex align-items-center justify-content-center fw-600">
									{isOpen.text}
								</div>
							)}
							{isOpen.open && hasPromo && (
								<div className="closed d-flex align-items-center justify-content-center fw-600">
									<div className="p-2 price">
										<i className="fa fa-gift" /> {hasPromo.description}
									</div>
								</div>
							)}
						</div>
						<div className="px-2- pb-2-">
							<div className="mt-1 fw-500">{func.venueName(item)}</div>
							<div className="text-muted small">
								{func.format.number(item.distance)}km away
							</div>
						</div>
					</div>
				)}
			</Touchable>
			<div className="mb-4" />
		</React.Fragment>
	);
};

export default Store;
